<template>
  <div v-bind:id="id"
       v-if="slots.length > 0">
      <banner v-for="(slot, index) in slots"
              v-bind:key="index"
              v-bind:value="slot"
              v-bind:label="index == 0 || labelAll ? label : null"
              v-bind:label-position="labelPosition"
              v-bind:wide="wide"
              v-bind:rendered="rendered"
              v-bind:style="slots.length > 1 ? 'margin-bottom: 1rem;' : ''"/>
  </div>
</template>

<script>
import Vue from "vue"
import MediaWidth from "../plugins/media-width"
Vue.use(MediaWidth)
export default {
  name: "banners",
  props: ["id", "value", "label", "label-position", "label-all", "max-slots", "guideline-size", "xs", "sm", "md", "lg", "wide", "callback", "initialized", "rendered"],
  data: function () {
    return {
      fullContainer: 1,
      standardContainer: 2,
      mediaWidths: ["xs", "sm", "md", "lg"],
      mediaWidth: Vue.$mediaWidth(),
      shuffled: []
    };
  },
  created: function () {
    var instance = this;
    if (instance.value && instance.value.length > 0) {
      instance.shuffled = instance.shuffle(instance.value);
    }
    if (instance.initialized) {
      var notEmpty = instance.slots.length > 0;
      if (typeof instance.initialized == "function") {
        instance.$nextTick(function () {
          instance.initialized(notEmpty);
        });
      } else if (typeof instance.initialized == "string") {
        var fn = window[instance.initialized];
        if (typeof fn == "function") {
          instance.$nextTick(function () {
            fn(notEmpty);
          });
        }
      }
    }
    window.addEventListener("resize", instance.handleResize);
  },
  beforeDestroy: function () {
    window.removeEventListener("resize", this.handleResize);
  },
  computed: {
    computedMaxSlots: function () {
      if (this.maxSlots != null && this.maxSlots > 0) {
        return this.maxSlots;
      }
      return 1;
    },
    computedGuidelineSize: function () {
      if (this.guidelineSize != null && this.guidelineSize > 0) {
        return this.guidelineSize;
      }
      return 4;
    },
    sizes: function () {
      for (var i = this.mediaWidths.indexOf(this.mediaWidth); i >= 0; i--) {
        var mw = this.mediaWidths[i];
        var sizes = this[mw];
        if (sizes) {
          return sizes;
        }
      }
      return null;
    },
    slots: function () {
      var instance = this;
      var slots = [];
      var candidates = instance.slotCandidates;
      var banners = candidates.banners;
      var fillers = candidates.fillers;
      var next = function () {
        if (banners.length < instance.computedGuidelineSize && fillers.length > 0) {
          if (banners.length > 0) {
            return banners.splice(0, 1)[0];
          } else {
            return fillers.splice(0, 1)[0];
          }
        } else if (banners.length > 0) {
          return banners.splice(0, 1)[0];
        }
        return null;
      };
      for (var i = 0; i < instance.computedMaxSlots; i++) {
        var slot = next();
        if (slot) {
          slots.push(slot);
        }
      }
      return slots;
    },
    slotCandidates: function () {
      var banners = [], fillers = [];
      for (var i = 0; i < this.shuffled.length; i++) {
        var banner = this.shuffled[i];
        var creative = this.findCreative(banner);
        if (creative) {
          var candidate = {
            banner: banner,
            creative: creative
          };
          if (banner.filler) {
            fillers.push(candidate);
          } else {
            banners.push(candidate);
          }
        }
      }
      return {
        banners: banners,
        fillers: fillers
      };
    },
    reinitOnAnyResize: function () {
      for (var i = 0; i < this.slots.length; i++) {
        if (this.slots[i].creative.container == this.fullContainer) {
          return true;
        }
      }
      return false;
    }
  },
  methods: {
    shuffle: function (array) {
      var shuffled = [];
      for (var i = 0; i < array.length; i++) {
        shuffled.splice(
            Math.floor(Math.random() * (shuffled.length + 1)),
            0,
            array[i]);
      }
      return shuffled;
    },
    isImage: function (creative) {
      return !!creative.img;
    },
    isHtml5: function (creative) {
      return !!creative.html;
    },
    isScript: function (creative) {
      return !!creative.script;
    },
    findCreative: function (banner) {
      var sizes = this.sizes;
      var creatives = [];
      var mw = this.mediaWidth;
      if (sizes && banner.creatives) {
        for (var i = 0; i < banner.creatives.length; i++) {
          var creative = banner.creatives[i];
          if (creative.mediaWidth == mw) {
            for (var j = 0; j < sizes.length; j++) {
              if (creative.width == sizes[j][0] && creative.height == sizes[j][1]) {
                creatives.push(creative);
              }
            }
          }
        }
      }
      if (creatives.length == 1) {
        return creatives[0];
      } else if (creatives.length > 1) {
        for (var k = 0; k < creatives.length; k++) {
          if (this.isScript(creatives[k])) {
            return creatives[k];
          }
        }
        for (var l = 0; l < creatives.length; l++) {
          if (this.isHtml5(creatives[l])) {
            return creatives[l];
          }
        }
        for (var m = 0; m < creatives.length; m++) {
          if (this.isImage(creatives[m])) {
            return creatives[m];
          }
        }
      }
      return null;
    },
    handleResize: function () {
      var mw = Vue.$mediaWidth();
      if (this.mediaWidth != mw || mw == "xs" || this.reinitOnAnyResize) {
        this.mediaWidth = mw;
      }
    }
  }
}
</script>
